import apiClient from '../apiClient';

export const getLocalidades = () => {
  return apiClient.get('localidades');
};
